import { useState } from "react";
import { heroStats, hotKeywords } from "@/mocks/home";

export default function HeroSection() {
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = () => {
    if (!keyword.trim()) {
      setHint("输入关键词开始速看，例如「今日最新瓜」");
      return;
    }
    setHint(`已按「${keyword.trim()}」整理站内速递，结果为演示展示`);
  };

  return (
    <section id="top" className="relative flex w-full items-center overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20collage%20of%20fragmented%20dark%20crimson%20and%20charcoal%20news%20print%20layers%2C%20glowing%20warm%20orange%20embers%2C%20thin%20teal%20green%20accent%20streaks%2C%20moody%20high%20contrast%20poster%20texture%2C%20cinematic%20grain%20and%20deep%20shadows%20for%20readable%20white%20text%20overlay%2C%20dramatic%20artistic%20atmosphere%2C%20no%20people%2C%20no%20text&width=1800&height=1040&seq=hl-yiqu-hero-01&orientation=landscape"
          alt="黑料一区今日新瓜速递主视觉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 pb-16 pt-36 md:px-8 md:pb-24 md:pt-48">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur">
            <span className="inline-flex h-1.5 w-1.5 rounded-full bg-accent-300 animate-softPulse" />
            新瓜速递 · 今日最新瓜快看
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-[1.15] text-background-50 md:text-5xl lg:text-6xl">
            黑料一区 · 新瓜速递
            <span className="mt-2 block text-primary-200">速看新料不迷路</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            今日最新瓜快看，热门爆料一站全。我们只做整理与标注，每条新料都写清来源与核实状态，
            让你在社区里安心讨论、理性跟话题。黑料一区新料速递持续更新，吃瓜不落后。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-50/25 bg-background-50/10 px-4 py-3 backdrop-blur">
              <i className="ri-search-line text-background-100/80" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                placeholder="输入关键词，速看今日最新瓜"
                className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-100/60"
              />
            </div>
            <button
              type="button"
              onClick={handleSearch}
              className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即速看
            </button>
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-100/70">大家都在看：</span>
            {hotKeywords.map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => setKeyword(word)}
                className="cursor-pointer rounded-full border border-background-50/25 bg-background-50/5 px-3 py-1 text-xs text-background-100 transition-colors hover:border-primary-300 hover:text-background-50"
              >
                {word}
              </button>
            ))}
          </div>

          {hint && (
            <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-50/12 px-3 py-2 text-xs text-background-100">
              <i className="ri-information-line text-accent-300" />
              {hint}
            </p>
          )}

          <div className="mt-10 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-6 md:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs text-background-100/70">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}